import { NgModule } from '@angular/core';

//******************************************************************************
//  Import Core Components
//******************************************************************************
import { CoreImports } from '../../core/classes/imports/core.imports';

//******************************************************************************
//  Services
//******************************************************************************

//******************************************************************************
//  Pages
//******************************************************************************
import { HomeComponent } from '../../pages/home/home.component';
import { GuideComponent } from '../../pages/guide/guide.component';
import { CitationsComponent } from '../../pages/citations/citations.component';

//******************************************************************************
//  Pipes
//******************************************************************************
import { SafePipe } from '../../core/pipes/safe.pipe';

@NgModule({
    imports: [
        CoreImports,
    ],
    declarations: [
        HomeComponent,
        GuideComponent,
        CitationsComponent,
        SafePipe,
    ],
    exports: [
        HomeComponent,
        GuideComponent,
        CitationsComponent,
    ],
    providers: [],
})

export class AppImports { }
